<!--- Create -->
<div class="modal-container-secondary" [hidden]="mode !== 'create'">
  <div class="modal-header">
    <h5 class="header-title">Create New Filter</h5>
  </div>

  <div class="modal-body">
    <div class="form-field">
      <label>Filter title:</label>
      <input class="input-wrapper" [(ngModel)]="filteringItems.new.name" />
    </div>
    <div class="form-field" *ngIf="!tool.integration.defaultmode.active">
      <label>Color:</label>
      <input class="input-colorpicker" [(ngModel)]="filteringItems.new.color" [value]="filteringItems.new.color"
        [style.background]="filteringItems.new.color" [(colorPicker)]="filteringItems.new.color" />
    </div>
    <div class="form-field">
      <label>Add inside:</label>
      <ng-multiselect-dropdown #multiselect [classList]="'input-dropdown filteringList'"
        [placeholder]="'Seleccionar elemento (' + dropdownData.length + ')'" [settings]="dropdownSettings"
        [data]="dropdownData" [(ngModel)]="dropdownSelected">
      </ng-multiselect-dropdown>
    </div>
    <div class="form-field" *ngIf="tool.integration.defaultmode.active">
      <div class="selector-div-wrapper mb-0">
        <label>Category:</label>
        <div class="selector-div">
          <select name="selector" class="selector" [(ngModel)]="filteringItems.new.type">
            <option [ngValue]="'vip'">VIP</option>
            <option [ngValue]="'regular'">Regular</option>
          </select>
          <div class="vertical-line"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" *ngIf="!confirmDelete">
    <button type="button" class="btn-sm-gray" (click)="cancelandclose()">Cancel</button>
    <button type="button" class="btn-sm-green" (click)="addNew()">Save</button>
  </div>
</div>

<!--- Edit -->
<div class="modal-container-secondary" *ngIf="mode === 'edit' && filteringItems.edit">
  <div class="modal-header">
    <h5 class="header-title">
      Edit filter: <span *ngIf="filteringItems.edit.name">{{ originaEditName }}</span>
    </h5>
  </div>

  <div class="modal-body">
    <div class="mb-4">
      <h6 class="body-title">Filter details</h6>
      <div class="form-field">
        <p>Filter title:</p>
        <input class="input-wrapper" type="text" [(ngModel)]="filteringItems.edit.name" />
      </div>
      <div class="form-field" *ngIf="!tool.integration.defaultmode.active">
        <p>Color:</p>
        <input class="input-colorpicker" [(ngModel)]="filteringItems.edit.color" [value]="filteringItems.edit.color"
          [style.background]="filteringItems.edit.color" [(colorPicker)]="filteringItems.edit.color" />
      </div>
      <div class="form-field">
        <p>Add inside:</p>
        <ng-multiselect-dropdown #multiselect [classList]="'input-dropdown filteringList'"
          [placeholder]="'Seleccionar elemento (' + dropdownData.length + ')'" [settings]="dropdownSettings"
          [data]="dropdownData" [(ngModel)]="dropdownSelected">
        </ng-multiselect-dropdown>
      </div>
      <div class="form-field" *ngIf="tool.integration.defaultmode.active">
        <div class="selector-div-wrapper mb-0">
          <p>Category:</p>
          <div class="selector-div">
            <select name="selector" class="selector" [(ngModel)]="filteringItems.edit.type">
              <option [ngValue]="'vip'">VIP</option>
              <option [ngValue]="'regular'">Regular</option>
            </select>
            <div class="vertical-line"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-field">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="body-title">Associate</h6>
        <div class="mb-3 form-check form-switch">
          <input class="input-switch-sm form-check-input" type="checkbox" role="switch"
            [(ngModel)]="nodesSelection.pairup" (change)="switchFilteringInterface()"
            [checked]="nodesSelection.pairup" />
        </div>
      </div>

      <!-- New association switch, btn group radio switch -->
      <div class="d-flex justify-content-center">
        <div [hidden]="!nodesSelection.pairup" class="btn-group text-center" role="group"
          aria-label="Basic radio toggle button group">
          <input *ngIf="current_wid !== 6" type="radio" class="btn-check" name="mode" id="mode-filter"
            autocomplete="off" (change)="switchFilteringInterface('filter')"
            [checked]="nodesSelection.type === 'filter'">
          <label *ngIf="current_wid !== 6" class="btn-group-option" for="mode-filter">Sections/Seats</label>
          <input type="radio" class="btn-check" name="mode" id="mode-views" autocomplete="off"
            (change)="switchFilteringInterface('view360')" [checked]="nodesSelection.type === 'view360'">
          <label class="btn-group-option" for="mode-views">Views 360</label>
        </div>
      </div>
      <!-- Old association switches -->
      <!-- <div *ngIf="current_wid !== 6" [hidden]="!nodesSelection.pairup"
        class="d-flex-align-items-center-justify-content-between">
        <p>Sections/Seats</p>
        <div class="form-check form-switch">
          <input class="input-switch-sm form-check-input" type="checkbox" role="checkbox"
            (change)="switchFilteringInterface('filter')" [checked]="nodesSelection.type === 'filter'" />
        </div>
      </div>
      <div [hidden]="!nodesSelection.pairup" class="d-flex-align-items-center-justify-content-between">
        <p>Views 360</p>
        <div class="form-check form-switch">
          <input class="input-switch-sm form-check-input" type="checkbox" role="switch"
            (change)="switchFilteringInterface('view360')" [checked]="nodesSelection.type === 'view360'" />
        </div>
      </div> -->

      <div [hidden]="!nodesSelection.pairup">
        <div class="tabs mt-2">
          <div class="tab" *ngIf="!customOpts.ids.disable.tab">
            <button (click)="activeSelectionByIds()" [ngClass]="{ active: nodesSelection.ids.active }">
              ID's
            </button>
          </div>
          <div class="tab" *ngIf="!customOpts.map.disable.tab">
            <button (click)="activeSelectionByMap()" [ngClass]="{ active: nodesSelection.manually.active }">
              Map
            </button>
          </div>
        </div>

        <div *ngIf="nodesSelection.manually.active" class="tab-content map">
          <div class="form-check form-switch">
            <span>Navigate</span>
            <input id="togglemapselection" class="input-switch-sm form-check-input" type="checkbox" role="switch"
              (click)="toggleMapSelection()" [checked]="nodesSelection.manually.active" />
            <span>Select</span>
          </div>
        </div>

        <div class="mt-2">
          <div class="json-viewer-wrapper">
            <div class="mb-2">
              <input class="custom-input mt-0" [(ngModel)]="filteringItems.edit.venueid" type="text"
                placeholder="Venue ID" />
              <input class="custom-input" [(ngModel)]="filteringItems.edit.mapid" type="text"
                placeholder="{{ customOpts.ids.placeholder.mapid }}" />
            </div>
            <div class="json-viewer-app-content" *ngIf="!customOpts.ids.disable.list">
              <ngx-json-viewer [json]="nodesSelection.nodes" [expanded]="false"></ngx-json-viewer>
            </div>
          </div>
        </div>
        <div *ngIf="nodesSelection.ids.active && !customOpts.ids.disable.list" class="tab-content ids">
          <small>Enter the list of ID's separated by commas (S_1, S_1-2, S_1-2-3)</small>
          <div class="nodesIdList-wrapper">
            <div>
              <span>Section</span>
              <textarea (keyup)="parseTextareaSection()" [(ngModel)]="nodesSelection.ids.section"> </textarea>
            </div>
            <div>
              <span>Row</span>
              <textarea (keyup)="parseTextareaRow()" [(ngModel)]="nodesSelection.ids.row"> </textarea>
            </div>
            <div>
              <span>Seat</span>
              <textarea (keyup)="parseTextareaSeat()" [(ngModel)]="nodesSelection.ids.seat"> </textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" *ngIf="!confirmDelete">
    <button type="button" class="btn-sm-gray" (click)="cancelandclose()">Cancel</button>
    <button type="button" class="btn-sm-green" (click)="saveEditItem()">Save</button>
    <button type="button" class="btn-sm-red" (click)="confirmDelete = true">Delete</button>
  </div>
  <div class="modal-footer" *ngIf="confirmDelete">
    <div class="alert alert-light m-0">
      <span>This action can not be undone. Are you sure?</span>
      <div class="mt-2 d-flex justify-content-center align-items-center">
        <button type="button" class="btn-sm-gray" (click)="confirmDelete = false">Cancel</button>
        <button type="button" class="btn-sm-red" (click)="deleteEditItem()">Yes, delete</button>
      </div>
    </div>
  </div>
</div>